package com.milta.core.localization.translations.ro

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "PROFILUL ORGANIZAȚIEI",
    profileNameLabel = "Numele organizației",
    languageSectionTitle = "LIMBA INTERFEȚEI",
    languageSearchPlaceholder = "Caută o limbă...",
    languageMoreAvailable = "%d alte limbi disponibile",
    languageErrorGeneric = "A apărut o eroare. Vă rugăm să încercați din nou.",
    subscriptionSectionTitle = "ABONAMENT",
    subscriptionPlanLabel = "Plan",
    subscriptionBillingLabel = "Facturare",
    subscriptionRenewalLabel = "Următoarea reînnoire",
    subscriptionBillingMonthly = "Lunar",
    subscriptionBillingAnnual = "Anual",
    subscriptionPlanOrganisationLabel = "Organizație (Manager + echipă)",
    subscriptionPriceSuffix = "fără TVA / lună",
    subscriptionUnavailable = "Indisponibil",
    deleteSectionTitle = "Ștergeți organizația",
    deleteWarning = "Această acțiune este permanentă și ireversibilă.",
    deleteDescription = "Traseele și dovezile de livrare vor fi șterse. Conturile șoferilor vor fi disociate de organizație, dar nu vor fi niciodată șterse.",
    deleteConfirmLabel = "Pentru a confirma, introduceți numele organizației",
    deleteButton = "Ștergere definitivă",
    deleteFinalDialogTitle = "Confirmați ștergerea definitivă?",
    deleteFinalDialogMessage = "Această acțiune nu poate fi anulată. Organizația, traseele și dovezile de livrare vor fi șterse definitiv.",
    deleteErrorGeneric = "A apărut o eroare. Vă rugăm să încercați din nou.",
)
